module.exports = __webpack_public_path__ + "56cdde26c885cff5517d51331923f63e.jpg";